import { ActionIcons } from '../utility/constants';

/** Default UI icon name → API actionName (case-insensitive match in service). */
export const DEFAULT_RPE_ICON_ACTION_MAP: Record<string, string> = {
  [ActionIcons.add]: 'add',
  [ActionIcons.view]: 'view',
  [ActionIcons.edit]: 'edit',
  [ActionIcons.delete]: 'delete',
  [ActionIcons.downloadFile]: 'download file',
  [ActionIcons.print]: 'print',
  [ActionIcons.bulkEdit]: 'bulk edit',
  [ActionIcons.bulkview]: 'bulk view',
};

/** SPE operational modules — icon identityName → API actionName. */
export const SPE_OPERATIONAL_ICON_ACTION_MAP: Record<string, string> = {
  [ActionIcons.sendCbpClearance]: 'send for clearance',
  // SPEC-RSB-001 FR-006 — same permission as Send for Clearance until BA defines a new one (OQ-002).
  [ActionIcons.ccResubmit]: 'send for clearance',
  [ActionIcons.bulkGateway]: 'bulk gateway',
  [ActionIcons.bulkBag]: 'bulk bag',
  [ActionIcons.duplicate]: 'duplicate',
  [ActionIcons.autoRate]: 'auto-rate',
  [ActionIcons.unAutoRate]: 'un-auto-rate',
  [ActionIcons.generateLabel]: 'print label',
  [ActionIcons.globe]: 'update ufo account',
  blockShipment: 'block/unblock',
  unblock: 'block/unblock',
};

/** Workflow / UI-only toolbar icons — not gated by R&P action permissions. */
export const RPE_NON_ACTION_ICON_NAMES = new Set<string>([
  ActionIcons.close,
  ActionIcons.save,
  ActionIcons.refresh,
  ActionIcons.advancedSearchTrigger,
  ActionIcons.advancedSearchHelp,
  ActionIcons.advancedSearchPinHeader,
  ActionIcons.advancedSearchHamburgerHeader,
  ActionIcons.bulkRouting,
  ActionIcons.bulkPod,
]);
